(function() {
    function loadDailyTaskStatus(action) {
        $.ajax({
            url: '/daily_task_act.php',
            type: 'POST',
            data: { a: action || 'getTaskCenterStatus' },
            dataType: 'json',
            success: function(res) {
                if (res.success === 0 && res.data && res.data.periods) {
                    updateBanner(res.data.bannerImg);
                    var tasks = [];
                    res.data.periods.forEach(function(period) {
                        tasks = tasks.concat(period.tasks);
                    });
                    if (tasks.length) {
                        renderTasks(tasks);
                    } else {
                        $('#dailyTaskList').html('<div class="loading-text">目前沒有進行中的任務</div>');
                    }
                } else {
                    var errorMsg = res.msg || '活動載入失敗';
                    $('#dailyTaskList').html('<div class="loading-text">' + errorMsg + '</div>');
                }
            },
            error: function() {
                $('#dailyTaskList').html('<div class="loading-text">網路錯誤，請稍後再試</div>');
            }
        });
    }

    function updateBanner(img) {
        if (!img) return;
        var $banner = $('#dailyTaskBanner');
        if (!$banner.length) return;
        var src = $banner.attr('src') || '';
        var base = src.split('?')[0].replace(/[^/]+$/, '');
        var ver = (src.split('?')[1] || '');
        $banner.attr('src', base + img + (ver ? '?' + ver : ''));
    }

    function fmt(n) {
        return (Number(n) || 0).toLocaleString();
    }

    function renderTasks(tasks) {
        var html = '';
        tasks.forEach(function(task, index) {
            var statusClass = task.status;
            var btnText = '';

            switch (task.status) {
                case 'locked':    btnText = '未解鎖'; break;
                case 'incomplete': btnText = '未達成'; break;
                case 'completed':  btnText = '領取';   break;
                case 'claimed':    btnText = '✓ 已領取'; break;
            }

            var progressHtml = '';
            if (task.status === 'incomplete' && task.conds.length) {
                var first = task.conds[0];
                var pct = first.max ? Math.max(0, Math.min(Math.round(first.cur / first.max * 100), 100)) : 0;
                progressHtml = '<div class="task-progress"><div class="task-progress-bar" style="width:' + pct + '%"></div></div>';
            }

            var subText = task.conds.map(function(c) {
                return c.label + ' ' + fmt(c.cur) + '/' + fmt(c.max) + (c.done ? '✓' : '');
            }).join('<br>');

            html += '<div class="daily-task-item ' + statusClass + '" data-bonus-id="' + task.bonusId + '">';
            html += '  <div class="task-index">' + (index + 1) + '</div>';
            html += '  <div class="task-info">';
            html += '    <div class="task-name">' + task.name + '</div>';
            if (subText) {
                html += '    <div class="task-subtext">' + subText + '</div>';
            }
            html += progressHtml;
            html += '  </div>';
            html += '  <div class="task-reward">';
            html += '    <span class="reward-amount">+' + task.amount + '</span>';
            html += '  </div>';
            html += '  <div class="task-action">';
            html += '    <button class="task-btn ' + statusClass + '">' + btnText + '</button>';
            html += '  </div>';
            html += '</div>';
        });

        $('#dailyTaskList').html(html);
    }

    $(document).on('click', '#DailyTask .daily-task-item .task-btn.completed', function() {
        var $item = $(this).closest('.daily-task-item');
        var $btn = $(this);
        var bonusId = $item.data('bonus-id');

        if ($btn.prop('disabled')) return;
        $btn.prop('disabled', true).text('領取中...');

        $.ajax({
            url: '/daily_task_act.php',
            type: 'POST',
            data: { a: 'claimTaskCenter', BonusID: bonusId },
            dataType: 'json',
            success: function(res) {
                if (res.success === 0) {
                    Swal.fire('領取成功', res.msg || '彩金已發放至您的帳戶', 'success');
                    loadDailyTaskStatus('refreshTaskCenter');
                    if (typeof app !== 'undefined' && typeof app.getMasterBalance === 'function') {
                        app.getMasterBalance();
                    }
                } else {
                    Swal.fire('領取失敗', res.msg || '請稍後再試', 'error');
                    $btn.prop('disabled', false).text('領取');
                }
            },
            error: function() {
                Swal.fire('網路錯誤', '請稍後再試', 'error');
                $btn.prop('disabled', false).text('領取');
            }
        });
    });

    // Modal 顯示時載入任務
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
            if (m.target.id === 'DailyTask' && m.target.style.display !== 'none') {
                loadDailyTaskStatus();
            }
        });
    });
    var el = document.getElementById('DailyTask');
    if (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['style'] });
    }
})();
